import React, { Component } from 'react'
import DataTable from '../../../../DataTable/DataTable'
import { withTranslate } from 'react-redux-multilingual'

class IndexTable extends Component {
  state = {
    gradeData: [],
    data: [],
    filterData: [],
    adjustData: []
  }

  static getDerivedStateFromProps(props, state) {
    if (typeof props.filterData !== 'undefined') {
      if (props.filterData !== state.filterData) {
        let update = props.filterData.map(item => {
          let individual_kpi = ''
          let attendance = ''
          let competency = ''
          let struc = ['STT02', 'STT05']
          item.force_rank_structure.map(str => {
            if (str.result_structure === null) {
              individual_kpi = str.weight_score
            } else {
              if (str.result_structure.structure.structure_type.value_list_code === 'STT01') {
                individual_kpi = str.weight_score
              } else if (
                str.result_structure.structure.structure_type.value_list_code === 'STT03'
              ) {
                attendance = str.weight_score
              } else if (
                str.result_structure.structure.structure_type.value_list_code === 'STT02'
              ) {
                competency = str.weight_score
              } else if (
                struc.includes(str.result_structure.structure.structure_type.value_list_code)
              ) {
                competency = str.weight_score
              }
            }
            return str
          })
          return {
            ...item,
            emp_code: item.emp_detail.emp.emp_code,
            emp_name: item.emp_detail.emp.full_name,
            org_name: item.emp_detail.org.org_name,
            level_name: item.emp_detail.level.level_name,
            level_group: item.emp_detail.level?.level_group?.level_group_name,
            position_name: item.emp_detail.position?.position_name,
            individual_kpi: individual_kpi,
            attendance: attendance,
            competency: competency
          }
        })
        return {
          filterData: update
        }
      }
    }
    return null
  }

  onPageChangeHandler = (event, page) => {
    let param = {
      company_id: this.props.filterControls.company_id.value.value,
      form_id: this.props.filterControls.form_id.value.value,
      org_id: this.props.filterControls.org_id.value.value,
      page: page ? page : 1,
      perPage: this.props.pagination.perPage ? this.props.pagination.perPage : 10
    }
    this.props.fetchAdjust(param)
  }

  onPerPageChangeHandler = perPage => {
    let param = {
      company_id: this.props.filterControls.company_id.value.value,
      org_id: this.props.filterControls.org_id.value.value,
      form_id: this.props.filterControls.form_id.value.value,
      currentPage: this.props.pagination.currentPage,
      perPage: perPage ? perPage : 10
    }
    this.props.fetchAdjust(param)
  }

  structureForIndex = [
    {
      field: 'index',
      title: '#',
      width: 40
    },
    { field: 'emp_code', title: this.props.translate('empCode'), type: 'string' },
    { field: 'emp_name', title: this.props.translate('employeeName'), type: 'string' },
    { field: 'org_name', title: this.props.translate('organizationName'), type: 'string' },
    { field: 'level_name', title: this.props.translate('level'), type: 'string' },
    { field: 'level_group', title: this.props.translate('levelGroup'), type: 'string' },
    { field: 'position_name', title: this.props.translate('position'), type: 'string' },
    { field: 'individual_kpi', title: this.props.translate('individualKPI'), type: 'string' },
    { field: 'competency', title: this.props.translate('competencyName'), type: 'string' },
    { field: 'attendance', title: this.props.translate('attendance'), type: 'string' },
    { field: 'force_rank_index', title: this.props.translate('forceRankIndex'), type: 'string' }
  ]

  render() {
    let table = null
    if (this.props.gradeData.length !== 0) {
      table = (
        <DataTable
          tableTitle={this.props.translate('indexTable')}
          data={this.state.filterData}
          structure={this.structureForIndex}
          loading={this.props.loading}
          pagination={this.props.pagination}
          pageChange={this.onPageChangeHandler}
          perPageChange={this.onPerPageChangeHandler}
          rowActions={this.rowActions}
        />
      )
    }

    return <div>{table}</div>
  }
}

export default withTranslate(IndexTable)
